// extracted by mini-css-extract-plugin
export default {"plusminus":"PlusMinusButton_plusminus__W5EqP"};